export enum LoginAccountType {

    CFD = 1,
    Invest = 2,
    Quantum = 3,
}
